export default function getFormatedMoney(money: number): string {
  if (!money) return '';

  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });

  return formatter.format(money);
}
